import ApiService from '@/services/ApiService'
import { useGlobalStore } from '@/stores/global'



const Roles = {
    User: 'User',
    Advertiser: 'Advertiser',
    Publisher: 'Publisher',
    Manager: 'Account Manager',
    Moderator: 'Moderator',
    Admin: 'Admin',
    account_manager_advertiser: 'Account Manager (Advertiser)',
    account_manager_publisher: 'Account Manager (Publisher)',
    callcenter_agent: 'Callcenter Agent',
    media_buyer: 'MediaBuyer',
}

function getAvailableRoles() {
    return ApiService.get('roles')
    .then((response) => {
        return response.data.data
    })
    .catch((error) => {
        return error
    })
}

function userHasRole(_role) {
    return useGlobalStore().roles.value.includes(_role)
}

function userHasAnyRole(_roles) {

    return useGlobalStore().roles.some((role) => _roles.includes(role))
}

function findUserRole(_role) {
    return Object.keys(Roles).find((key) => Roles[key] === _role)
}

function toAvailableFilterArray() {
    return Object.entries(Roles)
        .map(([key, value]) => {
            return {
                value: key,
                title: value,
            }
        })
        .sort(function (a, b) {
            if (a.title > b.title) {
                return 1
            }
            if (a.title < b.title) {
                return -1
            }
            return 0
        })
}

const RolesHelper = {
    Roles,
    toAvailableFilterArray,
    findUserRole,
    getAvailableRoles,
    userHasRole,
    userHasAnyRole,
}

export default RolesHelper
